import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useMe } from '../api/hooks';

// Client-side gate for admin-only pages. This is UX only — the API enforces
// the real authorization on every request.
export default function RequireAdmin({ children }: { children: ReactNode }) {
  const { data: me, isLoading } = useMe();

  if (isLoading) return <p className="muted">Checking access…</p>;
  if (!me?.roles.isAdmin) return <Navigate to="/" replace />;
  return <>{children}</>;
}
